import Layout from './components/layout/Layout';
import Home from './pages/Home.tsx';
import Map from './pages/Map';
import WebVR from './pages/WebVR';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Exhibits from './pages/Exhibits.tsx';
import Lectures from './pages/Lectures';
import FabVan from './pages/FabVan';
import GameBasedLearning from './pages/GameBasedLearning';
import Research from './pages/Research';
import Publications from './pages/Publications';
import Register from './pages/Register';
import SensorBox from './pages/SensorBox';
import { AuthProvider } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Navigate to="/project/research" replace />} />
          <Route path="/project/research" element={<Research />} />
          <Route path="/project/publications" element={<Publications />} />
          <Route path="/map" element={
            <div className="h-[calc(100vh-8rem)] w-full relative">
              <Map />
            </div>
          } />
          <Route path="/webvr" element={<WebVR />} />
          <Route path="/community" element={<Navigate to="/community/exhibits" replace />} />
          <Route path="/community/exhibits" element={<Exhibits />} />
          <Route path="/community/lectures" element={<Navigate to="/education/lectures" replace />} />
          <Route path="/community/fabvan" element={<FabVan />} />
          <Route path="/education" element={<Navigate to="/education/lectures" replace />} />
          <Route path="/education/lectures" element={<Lectures />} />
          <Route path="/education/immersive-experience" element={<Navigate to="/education/lectures" replace />} />
          <Route path="/education/game-based-learning" element={<GameBasedLearning />} />
          <Route path="/teaching" element={<Navigate to="/education/game-based-learning" replace />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/sensorbox"
            element={
              <RequireAuth>
                <SensorBox />
              </RequireAuth>
            }
          />
        </Routes>
      </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
